export const FONT_COLOR = "#E5E5E5";
export const BACKGROUND_COLOR = "#14213D";
export const TIMELINE_FONT_COLOR = "#000000";

export const ACCENT_YELLOW_COLOR = "#f6c411";


export const HEADER_FONT = 'Roboto'
export const TEXT_FONT = 'sans-serif';
